export enum FbqActionEnum {
    ADD_PAYMENT_INFO = 'AddPaymentInfo',
}
